import { render, staticRenderFns } from "./AddMarketplace.vue?vue&type=template&id=003c6532&scoped=true&"
import script from "./AddMarketplace.vue?vue&type=script&lang=js&"
export * from "./AddMarketplace.vue?vue&type=script&lang=js&"
import style0 from "./AddMarketplace.vue?vue&type=style&index=0&id=003c6532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003c6532",
  null
  
)

export default component.exports